import React from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";

const propTypes = {
	offer: PropTypes.object
};

const defaultProps = {
	offer: undefined,
};

const mapStateToProps = (state) => {
	return {
		offer: state.app.offer,
	};
};

class Profile extends React.Component {
    constructor(props) {
        super(props);
    }

    formatSSN(ssn) {
        return <li><strong>SSN: </strong> ***-**-{ssn.slice(7)}</li>;
    }

    formatPersonalInfo(label, value ) {
        if (value) {
            return <li><strong>{label} </strong> {value}</li>;
        } else {
            return null;
        }
    }

    formatAddress(address1, address2, city, state, zip ) {
        if ((address1) || (address2) || (city) || (state) || (zip)) {
            let address = address1;
            if (address2) {
                address = address + ', ' + address2;
            }
            if (city) {
                address = address + ', ' + city;
            }
            if (state) {
                address = address + ' ' + state;
            }
            if (state) {
                address = address + ' ' + zip;
            }
            return <li><strong> Address: </strong> {address}</li>;
        } else {
            return null;
        }
    }

    render() {
        return (
            <section>
                < ul className="content">
                    <li><strong>{this.props.offer.firstName} {this.props.offer.middleName} {this.props.offer.lastName}</strong></li>
                    {this.formatAddress(this.props.offer.address1, this.props.offer.address2,this.props.offer.city, this.props.offer.state, this.props.offer.zip)}
                    {this.formatPersonalInfo('Phone: ', this.props.offer.homePhone)}
                    {this.formatPersonalInfo('DOB: ', this.props.offer.birthDate)}
                    {this.formatPersonalInfo('Email: ', this.props.offer.personalEmail)}
                    {this.props.offer.socialSecurityNumber && this.formatSSN(this.props.offer.socialSecurityNumber)}
                </ul>
            </section>
        );
    }
}

Profile.propTypes = propTypes;
Profile.defaultProps = defaultProps;

export default connect(mapStateToProps)(Profile);